import React from "react"
import { Redirect } from 'react-router-dom'
import CurrencyEditContent from '../../../components/Dashboard/Workspace/CurrencyEditContent'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { FormLoader } from '../../../components/Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import { SEO } from '../../../components/Seo/seo'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { CurrencyProvider } from "../../../CurrencyContext"
import { currencies } from '../../../utils/pages-meta.json'

const SingleCurrencyAdd = () => {
  const intl = useIntl()

  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Currencies.Form.AddTitle' })}
        pathname={window.location.origin}
        titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
        image={currencies.image}
        description={intl.formatMessage({ id: 'Currencies.Form.AddTitle' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true} />}
            {!!Object.keys(userData).length &&
              <>
                {!!userData.is_admin ?
                  <Layout content={
                    <CurrencyProvider handleNotificationCall={handleNotificationCall}>
                      <CurrencyEditContent
                        pageTitle={<FormattedMessage id='Currencies.Form.AddTitle' />}
                      />
                    </CurrencyProvider>
                  } />
                  :
                  (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                }
              </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SingleCurrencyAdd

